import {
  ReadOutlined,
  FileImageOutlined,
  PictureOutlined,
  SafetyOutlined,
  ScheduleOutlined,
  InfoCircleOutlined,
  LockOutlined,
  RollbackOutlined,
  QuestionCircleOutlined,
  PlaySquareOutlined,
  CustomerServiceOutlined,
  BulbOutlined,
} from '@ant-design/icons';

const cms = {
  id: 'group-cms',
  title: 'CMS',
  type: 'group',
  children: [
    {
      id: 'cms-collapse',
      title: 'Content Management',
      type: 'collapse',
      icon: ReadOutlined,
      children: [
       
        { id: 'cms-about', title: 'About Us', type: 'item', url: '/cms/about-us', icon: InfoCircleOutlined },
        { id: 'cms-refund', title: 'Refund Policy', type: 'item', url: '/cms/refundPolicy', icon: RollbackOutlined },
        { id: 'cms-privacy', title: 'Privacy Policy', type: 'item', url: '/cms/privacyPolicy', icon: LockOutlined },
        { id: 'cms-terms', title: 'Terms & Conditions', type: 'item', url: '/cms/termsConditions', icon: SafetyOutlined },
        // { id: 'cms-contact', title: 'Contact Support', type: 'item', url: '/cms/contactSupport', icon: CustomerServiceOutlined },
        { id: 'cms-help', title: 'Help Center/FAQ', type: 'item', url: '/cms/faq', icon: QuestionCircleOutlined },
        { id: 'cms-smart-tips', title: 'Smart Tips', type: 'item', url: '/cms/smart-tips', icon: BulbOutlined },
      ]
    }
  ]
};

export default cms;
